/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
import React, { useState } from "react";
import styled from "styled-components";
import { Box } from "@mui/material";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { SERVICES } from "../../components/Layout/Services";
import { get } from "../../components/Layout/ApiHandler/apihandler";

const PageWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 70px);
  padding: 28px;
  background: #f4f6fa;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const HeaderCard = styled.div`
  padding: 24px 28px;
  border-radius: 12px;
  color: #ffffff;
  background: linear-gradient(135deg, #4c4e8d 0%, #273a70 100%);
  box-shadow: 0 8px 18px rgba(76, 78, 141, 0.22);
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
`;

const HeaderDescription = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  opacity: 0.9;
`;

const ContentCard = styled.div`
  margin-top: 24px;
  padding: 28px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(33, 41, 61, 0.1);

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Heading = styled.h2`
  margin: 0;
  color: #29293a;
  font-size: 18px;
  font-weight: 700;
`;

const SubHeading = styled.p`
  margin: 8px 0 24px;
  color: #707080;
  font-size: 14px;
`;

const DateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 7px;
  color: #3f4054;
  font-size: 14px;
  font-weight: 600;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #d9dce6;
  border-radius: 8px;
  outline: none;
  color: #30303c;
  font-size: 14px;

  &:focus {
    border-color: #4c4e8d;
    box-shadow: 0 0 0 3px rgba(76, 78, 141, 0.12);
  }

  &:disabled {
    cursor: not-allowed;
    background: #f1f2f5;
  }
`;

const Divider = styled.div`
  height: 1px;
  margin: 28px 0;
  background: #e7e8ee;
`;

const DownloadButton = styled.button`
  min-width: 220px;
  padding: 13px 20px;
  border: 0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  background: ${({ disabled }) => (disabled ? "#a8a9bf" : "#4c4e8d")};
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  transition: 0.2s ease;

  &:hover {
    background: ${({ disabled }) => (disabled ? "#a8a9bf" : "#393b75")};
  }
`;

const ProgressSection = styled.div`
  margin-top: 26px;
`;

const ProgressLabel = styled.div`
  margin-bottom: 9px;
  color: #515163;
  font-size: 14px;
  font-weight: 600;
`;

const ProgressTrack = styled.div`
  height: 9px;
  overflow: hidden;
  border-radius: 10px;
  background: #e8e9ef;
`;

const ProgressValue = styled.div`
  width: ${({ value }) => value}%;
  height: 100%;
  border-radius: 10px;
  background: linear-gradient(90deg, #4c4e8d, #6b72c4);
  transition: width 0.2s ease;
`;

const StatsGrid = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StatCard = styled.div`
  padding: 16px;
  border: 1px solid ${({ error }) => (error ? "#ffdada" : "#dfe4f1")};
  border-radius: 10px;
  background: ${({ error }) => (error ? "#fff8f8" : "#f9faff")};
`;

const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #707080;
  font-size: 13px;
`;

const StatValue = styled.div`
  margin-top: 8px;
  color: ${({ error }) => (error ? "#cc2c2c" : "#2d2e4d")};
  font-size: 24px;
  font-weight: 700;
`;

const Message = styled.div`
  margin-top: 22px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${({ error }) => (error ? "#fff0f0" : "#eff9f1")};
  color: ${({ error }) => (error ? "#c62828" : "#207632")};
  font-size: 14px;
`;

const getApiDate = (date, isEndDate = false) =>
  `${date}T${isEndDate ? "23:59:59" : "00:00:00"}`;

const wait = (time) =>
  new Promise((resolve) => {
    setTimeout(resolve, time);
  });

const getFileName = (url, page, index) => {
  try {
    const fileName = new URL(url).pathname.split("/").pop();
    if (fileName) {
      return fileName.split("?")[0] || `receipt_${page}_${index}.pdf`;
    }
  } catch (error) {
    console.error("Invalid PDF URL", error);
  }
  return `receipt_${page}_${index}.pdf`;
};

const triggerNativeDownload = async (url, page, index) => {
  const fileName = getFileName(url, page, index);

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  anchor.download = fileName;
  anchor.style.display = "none";

  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  await wait(1200);
};

function BulkReceiptDownload() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [total, setTotal] = useState(0);
  const [downloaded, setDownloaded] = useState(0);
  const [failed, setFailed] = useState(0);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleDownload = async () => {
    if (!fromDate || !toDate) {
      setIsError(true);
      setMessage("Please select both From Date and To Date.");
      return;
    }

    if (new Date(fromDate) > new Date(toDate)) {
      setIsError(true);
      setMessage("From Date cannot be greater than To Date.");
      return;
    }

    const memberId = localStorage.getItem("memberId");

    if (!memberId) {
      setIsError(true);
      setMessage("Member ID is not available. Please login again.");
      return;
    }

    setIsDownloading(true);
    setTotal(0);
    setDownloaded(0);
    setFailed(0);
    setMessage("");
    setIsError(false);

    let page = 0;
    let downloadedCount = 0;
    let failedCount = 0;
    const pageSize = 500;

    try {
      while (true) {
        const response = await get(
          `${
            SERVICES.GET_BULK_RECEIPT_DOWNLOAD
          }/${memberId}/get-receipts-second?fromDate=${encodeURIComponent(
            getApiDate(fromDate),
          )}&toDate=${encodeURIComponent(
            getApiDate(toDate, true),
          )}&page=${page}&size=${pageSize}`,
        );

        if (!response?.ok) {
          throw new Error("Receipt list could not be fetched.");
        }

        const result = await response.json();

        if (result?.error) {
          throw new Error(
            result?.message || "Receipt list could not be fetched.",
          );
        }

        const receiptPage = result?.data;
        const receiptUrls = receiptPage?.content || [];

        if (receiptUrls.length === 0) break;

        setTotal((prev) => prev + receiptUrls.length);

        for (let index = 0; index < receiptUrls.length; index += 1) {
          try {
            await triggerNativeDownload(receiptUrls[index], page, index + 1);
            downloadedCount += 1;
            setDownloaded(downloadedCount);
          } catch (error) {
            console.error(error);
            failedCount += 1;
            setFailed(failedCount);
          }
        }

        if (receiptPage?.last) break;
        page += 1;
      }

      setIsError(false);
      setMessage(
        `Download Triggered. Attempted: ${downloadedCount}, Failed: ${failedCount}.`,
      );
    } catch (error) {
      console.error(error);
      setIsError(true);
      setMessage(
        error?.message || "Something went wrong while downloading receipts.",
      );
    } finally {
      setIsDownloading(false);
    }
  };

  const completed = downloaded + failed;
  const progress = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <PageWrapper>
      <HeaderCard>
        <HeaderTitle>
          <ArrowCircleDownIcon sx={{ fontSize: 30 }} />
          <Title>Bulk Receipt Download</Title>
        </HeaderTitle>
        <HeaderDescription>
          Select a date range and download all available receipt PDFs.
        </HeaderDescription>
      </HeaderCard>

      <ContentCard>
        <Heading>Select Receipt Date Range</Heading>
        <SubHeading>
          Select From Date and To Date, then click Start Bulk Download.
        </SubHeading>

        <DateGrid>
          <Field>
            <Label htmlFor="bulk-from-date">
              <CalendarMonthIcon sx={{ fontSize: 18 }} />
              From Date
            </Label>
            <Input
              id="bulk-from-date"
              type="date"
              value={fromDate}
              max={toDate || undefined}
              disabled={isDownloading}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Field>

          <Field>
            <Label htmlFor="bulk-to-date">
              <CalendarMonthIcon sx={{ fontSize: 18 }} />
              To Date
            </Label>
            <Input
              id="bulk-to-date"
              type="date"
              value={toDate}
              min={fromDate || undefined}
              disabled={isDownloading}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Field>
        </DateGrid>

        <Divider />

        <DownloadButton
          type="button"
          disabled={isDownloading}
          onClick={handleDownload}
        >
          {isDownloading ? (
            <>
              <CircularProgress size={19} color="inherit" />
              Downloading Receipts...
            </>
          ) : (
            <>
              <DownloadIcon sx={{ fontSize: 20 }} />
              Start Bulk Download
            </>
          )}
        </DownloadButton>
        {/* Note below download button */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            backgroundColor: "#FFF8E1",
            border: "1px solid #FFE082",
            borderRadius: "8px",
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "#8A6D3B", lineHeight: 1.6 }}
          >
            <strong>Note:</strong> If you want to download receipts to a
            specific folder, please change your browser's default download
            folder before starting the bulk download.
          </Typography>
        </Box>

        {(isDownloading || total > 0) && (
          <>
            <ProgressSection>
              <ProgressLabel>
                Download Progress: {completed} / {total} ({progress}%)
              </ProgressLabel>
              <ProgressTrack>
                <ProgressValue value={progress} />
              </ProgressTrack>
            </ProgressSection>

            <StatsGrid>
              <StatCard>
                <StatLabel>
                  <PictureAsPdfIcon sx={{ fontSize: 18 }} />
                  Receipts Found
                </StatLabel>
                <StatValue>{total}</StatValue>
              </StatCard>

              <StatCard>
                <StatLabel>
                  <CheckCircleOutlineIcon sx={{ fontSize: 18 }} />
                  Downloaded
                </StatLabel>
                <StatValue>{downloaded}</StatValue>
              </StatCard>

              <StatCard error>
                <StatLabel>
                  <ErrorOutlineIcon sx={{ fontSize: 18 }} />
                  Failed
                </StatLabel>
                <StatValue error>{failed}</StatValue>
              </StatCard>
            </StatsGrid>
          </>
        )}

        {message && <Message error={isError}>{message}</Message>}
      </ContentCard>
    </PageWrapper>
  );
}

export default BulkReceiptDownload;
